import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
// reducer function
function filterReducer(state, action) {
  switch (action.type) {
    case "LOADING_TRUE": {
      return {
        ...state,
        loading: true,
      };
    }
    case "LOADING_FALSE": {
      return {
        ...state,
        loading: false,
      };
    }
    case "CLEAR_ALL": {
      return {
        ...state,
        appoint_type: "",
        appoint_date: "",
        appointment_status: "",
        appoint_date_from: "",
      };
    }
    default: {
      return {
        ...state,
        [action.target.name]: action.target.value,
      };
    }
  }
}
//
// Admin related filter search form
export default function FilterForm({ onDateChange }) {
  const filter_status = {
    appoint_type: useSelector((state) => state.consultationFilterReducer.value),

    appointment_status: useSelector(
      (state) => state.consultationFilterReducer.value1
    ),
    appoint_date: useSelector(
      (state) => state.consultationFilterReducer.value2
    ),
    appoint_date_from: useSelector(
      (state) => state.consultationFilterReducer.value3
    ),
  };
  const [formData, setFormDataDispatch] = React.useReducer(filterReducer, {
    appoint_type: filter_status.appoint_type,
    appoint_date: filter_status.appoint_date || "",
    appoint_date_from: filter_status.appoint_date_from || "",
    appointment_status: filter_status.appointment_status,
    loading: false,
  });
  //
  const dispatch = useDispatch();
  //
  const {
    appoint_type,
    appoint_date,
    appointment_status,
    appoint_date_from,
    loading,
  } = formData;
  // this is will handle submit

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormDataDispatch({ type: "LOADING_TRUE" });
    if (appoint_type !== undefined) {
      dispatch({
        type: "consultationFilter/" + appoint_type,
      });
      setTimeout(() => {
        setFormDataDispatch({ type: "LOADING_FALSE" });
        dispatch({ type: "tableFilterModal/setHideModal" });
      }, 1000);
    }
    if (appointment_status !== undefined) {
      dispatch({
        type: "consultationFilter/" + appointment_status,
      });
      setTimeout(() => {
        setFormDataDispatch({ type: "LOADING_FALSE" });
        dispatch({ type: "tableFilterModal/setHideModal" });
      }, 1000);
    }
    if (appoint_date !== undefined) {
      dispatch({
        type: "consultationFilter/appoint_date",
        payload: appoint_date,
      });
      setTimeout(() => {
        setFormDataDispatch({ type: "LOADING_FALSE" });
        dispatch({ type: "tableFilterModal/setHideModal" });
      }, 1000);
      if (appoint_date_from !== undefined) {
        dispatch({
          type: "consultationFilter/appoint_date_from",
          payload: appoint_date_from,
        });
        setTimeout(() => {
          setFormDataDispatch({ type: "LOADING_FALSE" });
          dispatch({ type: "tableFilterModal/setHideModal" });
        }, 1000);
      }
    }
  };
  //
  return (
    <>
      <form onSubmit={handleSubmit} className="mt-4 p-2">
        <div className="form-group mt-3">
          <label for="exampleFormControlSelect1" style={{ fontWeight: 400 }}>
            Consultation Type
          </label>
          <select
            className="form-control"
            id="exampleFormControlSelect1"
            onChange={setFormDataDispatch}
            name="appoint_type"
            value={appoint_type}
          >
            <option name="all" value="videoCall">
              All
            </option>
            <option value="Booked">Book Appointment video</option>
            <option value="Instant">Instant Consultation Video</option>
            <option value="FollowUp">FollowUp Consultation Video</option>
          </select>
        </div>
        <div className="form-group mt-3">
          <label for="exampleFormControlSelect1" style={{ fontWeight: 400 }}>
            Consultation Status
          </label>
          <select
            className="form-control filter-input my-2"
            id="exampleFormControlSelect1"
            onChange={setFormDataDispatch}
            name="appointment_status"
            value={appointment_status}
          >
            <option name="all" value={"all"}>
              All
            </option>
            <option value={"booked"}>Booked</option>
            <option value={"completed"}>Completed</option>
            <option value={"testCall"}>Test Call</option>
            <option value={"fakeCall"}>Fake Call</option>
            <option value={"cancelled"}>Cancelled</option>
            <option value={"InProgress"}>InProgress</option>
            <option value={"missed"}>Missed</option>
            <option value={"unattended"}>Unattended</option>
            <option value={"called"}>Called</option>
            <option value={"reschedule"}>Reschedule</option>
          </select>
        </div>
        <div class="form-group mt-3 ">
          <label for="exampleFormControlSelect1" style={{ fontWeight: 400 }}>
            Appointment Date From
          </label>
          <input
            onChange={setFormDataDispatch}
            name="appoint_date_from"
            type="date"
            className="form-control filter-input"
            id=" exampleFormControlSelect1"
            value={appoint_date_from}
          />
        </div>
        <div class="form-group mt-3 ">
          <label for="exampleFormControlSelect1" style={{ fontWeight: 400 }}>
            Appointment Date To
          </label>
          <input
            onChange={setFormDataDispatch}
            name="appoint_date"
            type="date"
            className="form-control filter-input"
            id=" exampleFormControlSelect1"
            value={appoint_date}
          />
        </div>

        <button type="submit" className="btn mt-3 filter-form-button">
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              style={{ marginRight: "20px" }}
            />
          )}{" "}
          {loading || "Apply"}
        </button>
        <button
          type="button"
          className="btn text-primary mt-3"
          onClick={() => {
            setFormDataDispatch({ type: "CLEAR_ALL" });
            dispatch({ type: "consultationFilter/clearFilters" });
            // dispatch({ type: "tableFilterModal/setHideModal" });
          }}
        >
          Clear all
        </button>
      </form>
      <style jsx="true">{`
        .filter-form-button {
          background: #009b93;
          color: #fff;
          width: 100%;
        }
        .filter-form-button:hover {
          color: #fff;
          background: #009b93 !important;
        }
        .filter-input:focus {
          border-color: #009b93 !important;
          box-shadow: 0 0 0 0.2rem rgba(0, 155, 148, 25%) !important;
        }
        select option:hover {
          background: #009b93 !important;
        }
      `}</style>
    </>
  );
}
